import axios from 'axios'

export enum DocusignDocumentName {
  Financing_Disclosure = 'Financing_Disclosure',
  Credit_Agreement = 'Credit_Agreement',
}

export enum ClickWrapStatus {
  NOT_STARTED = 'NOT_STARTED',
  AGREED = 'AGREED',
  DECLINED = 'DECLINED',
  INVALID = 'INVALID',
}

export interface ClickWrap {
  createdBy: string
  dateCreated: string
  dateExpired: string
  dateTermsAccepted: string
  docusignDocumentName: string
  docusignDocumentVersion: string
  docusignId: string
  status: ClickWrapStatus
  team: string
}

export function getDocusignClickWrap({
  documentName,
}: {
  documentName: DocusignDocumentName
}): Promise<ClickWrap> {
  return axios
    .post(`/api/v1/docusign-documents/get-clickwrap/`, {
      docusign_document_name: documentName,
    })
    .then((res) => parseClickWrap(res.data))
}

export function parseClickWrap(data: any): ClickWrap {
  return {
    createdBy: data.created_by,
    dateCreated: data.date_created,
    dateExpired: data.date_expired,
    dateTermsAccepted: data.date_terms_accepted,
    docusignDocumentName: data.docusign_document_name,
    docusignDocumentVersion: data.docusign_document_version,
    docusignId: data.docusign_id,
    status: data.status,
    team: data.team,
  }
}

export function agreeDocusignClickWrap({ documentName }: { documentName: DocusignDocumentName }) {
  return axios.post(`/api/v1/docusign-documents/agree_clickwrap/`, {
    docusign_document_name: documentName,
  })
}

export function declineDocusignClickWrap({ documentName }: { documentName: DocusignDocumentName }) {
  return axios.post(`/api/v1/docusign-documents/decline_clickwrap/`, {
    docusign_document_name: documentName,
  })
}
